export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Game',
          value: 'Game',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Prize Type',
          value: 'PrizeType',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Quantity',
          value: 'quantity',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Max Quantity',
          value: 'maxQuantity',
          sortable: false,
          filterable: false,
        },
      ],
    },
  },
  read:{
    tabs:[
      {
        key:'Info',
        label:'info',
      },
    ],
    table:{
      headers: [
        {
          text: 'Created',
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text: 'Last Updated',
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:false,
  edit:false,
  delete:false,
}